import React from "react";
import StaffLessonPlanCompletionReport from "../../components/StaffTabs/StaffLessonPlanCompletionReport/StaffLessonPlanCompletionReport";

const StaffLessonPlanCompletionReportPage = () => {
  return (
    <div>
      <StaffLessonPlanCompletionReport />
    </div>
  );
};

export default StaffLessonPlanCompletionReportPage;
